<template>
  <v-img
    v-if="$permissions().teamLogo"
    :width="size ? size : sizeDefault"
    :height="size ? size : sizeDefault"
    :max-width="size ? size : sizeDefault"
    :max-height="size ? size : sizeDefault"
    :src="src"
    @error="onError"
  />
</template>
<script>
export default {
  name: "team-logo",
  props: {
    size: {
      type: [String],
      default: null,
    },
    id_sport: {
      default: "6046",
    },
    id_team: {
      type: [String, Number],
    },
    type_size: {
      // 'xsmall_logo'  (16x16px),
      // 'small_logo'   (24x24px),
      // 'medium_logo'  (48x48px),
      // 'large_logo'   (100x100px),
      // 'xlarge_logo'  (512x512px),
      // 'xxlarge_logo' (1024x1024px);
      type: String,
      default: "xsmall_logo",
    },
  },
  data: () => ({
    sizeDefault: null,
    error: false,
  }),
  mounted() {
    switch (this.type_size) {
      case "xsmall_logo":
        this.sizeDefault = "16px";
        break;
      case "small_logo":
        this.sizeDefault = "24px";
        break;
      case "medium_logo":
        this.sizeDefault = "48px";
        break;
      case "large_logo":
        this.sizeDefault = "100px";
        break;
      case "xlarge_logo":
        this.sizeDefault = "512px";
        break;
      case "xxlarge_logo":
        this.sizeDefault = "1024px";
        break;
      default:
        this.sizeDefault = "16px";
        break;
    }
  },
  computed: {
    src() {
      if (!this.id_team || this.error) {
        return "https://dozr8la71aog.cloudfront.net/sports/all.png";
      }

      return `https://dozr8la71aog.cloudfront.net/sports/${this.id_sport}/${this.id_team}/${this.type_size}.png`;
    },
  },
  methods: {
    onError() {
      if (this.id_team) {
        this.error = true;
      }
    },
  },
};
</script>
